(function () {
    var CHECKBOX_ID = "rterms-0";
    var CHECKOUT_BTN_SELECTOR = "button[hpay_tosa]";
    var overlay = null;

    function removeOverlay() {
      if (overlay && overlay.parentNode) {
        console.log("[BulkPerk bridge] removing overlay");
        overlay.parentNode.removeChild(overlay);
      }
      overlay = null;
    }

    function createOverlay() {
      removeOverlay();
      var btn = document.querySelector(CHECKOUT_BTN_SELECTOR);
      if (!btn) {
        console.log("[BulkPerk bridge] checkout button not found, cannot create overlay");
        return;
      }
      var rect = btn.getBoundingClientRect();
      console.log("[BulkPerk bridge] creating overlay over checkout button", rect);

      overlay = document.createElement("div");
      overlay.setAttribute("data-bulkperk-overlay", "1");
      overlay.style.cssText =
        "display: block;" +
        "position:fixed;" +
        "top:" + rect.top + "px;" +
        "left:" + rect.left + "px;" +
        "width:" + rect.width + "px;" +
        "height:" + rect.height + "px;" +
        "z-index:2147483647;" +
        "cursor:pointer;" +
        "pointer-events:all;" +
        "background:rgba(0,0,0,0.001);";  /* must NOT be transparent — transparent divs fail hit-testing in some browsers */

      overlay.addEventListener("click", function (e) {
        console.log("[BulkPerk bridge] overlay clicked, dispatching bulkperk:checkout");
        e.preventDefault();
        e.stopImmediatePropagation();
        removeOverlay();
        var form = btn.form || (btn.closest ? btn.closest("form") : null);
        console.log("[BulkPerk bridge] captured form:", form);
        document.dispatchEvent(
          new CustomEvent("bulkperk:checkout", {
            detail: {
              onProceed: function () {
                console.log("[BulkPerk bridge] onProceed — navigating to /checkout");
                // Use direct navigation instead of form.submit() to bypass
                // any HPay-patched form.submit() that would re-check ToS
                window.location.href = "/checkout";
              }
            }
          })
        );
      });

      document.body.appendChild(overlay);
      console.log("[BulkPerk bridge] overlay appended to body");
    }

    function onCheckboxChange() {
      var tos = document.getElementById(CHECKBOX_ID);
      console.log("[BulkPerk bridge] checkbox change — checked:", tos && tos.checked);
      if (!tos || !tos.checked) {
        removeOverlay();
        return;
      }
      setTimeout(function () {
        var tosNow = document.getElementById(CHECKBOX_ID);
        if (!tosNow || !tosNow.checked) {
          console.log("[BulkPerk bridge] checkbox unchecked before timeout fired, aborting");
          return;
        }
        createOverlay();
      }, 8);
    }

    function attachCheckboxListener() {
      var tos = document.getElementById(CHECKBOX_ID);
      if (!tos) return false;
      console.log("[BulkPerk bridge] ToS checkbox found, attaching change listener");
      tos.addEventListener("change", onCheckboxChange);
      if (tos.checked) {
        console.log("[BulkPerk bridge] checkbox already checked on load");
        setTimeout(createOverlay, 8);
      }
      return true;
    }

    if (!attachCheckboxListener()) {
      console.log("[BulkPerk bridge] checkbox not in DOM yet, observing...");
      var observer = new MutationObserver(function () {
        if (attachCheckboxListener()) {
          console.log("[BulkPerk bridge] checkbox found via MutationObserver");
          observer.disconnect();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }

    window.addEventListener("resize", removeOverlay, { passive: true });
  })();